module.exports = __webpack_public_path__ + "static/media/suicidePrevention.c1f7fe35.jpg";